import type { SxProps, Theme } from "@mui/material/styles";

export const RADIO_SX_BASE = {
  p: 0,
  width: 14,
  height: 14,
  "& .MuiSvgIcon-root": { fontSize: 14 },
} as const;

export function getSelectedSlotChipSx(
  theme: Theme,
  passes: boolean,
  contrast: string
): SxProps<Theme> {
  const pillRadius = theme.spacing(0.75);
  return {
    borderRadius: pillRadius,
    bgcolor: passes ? "primary.dark" : "error.dark",
    color: contrast,
    "&:hover": {
      bgcolor: passes ? "primary.dark" : "error.dark",
      filter: "brightness(1.06)",
    },
  };
}

export function getSlotPillButtonSx(
  theme: Theme,
  passes: boolean
): SxProps<Theme> {
  const pillRadius = theme.spacing(0.75);
  return {
    borderRadius: pillRadius,
    borderColor: passes ? "divider" : "error.light",
    bgcolor: passes ? "background.paper" : "error.light",
    color: passes ? "text.primary" : "error.main",
    cursor: passes ? "pointer" : "not-allowed",
    "&:hover": {
      borderColor: passes ? "primary.light" : "error.dark",
      bgcolor: passes ? "background.paper" : "error.light",
    },
  };
}

export function getSelectedRadioSx(contrast: string): SxProps<Theme> {
  return {
    ...RADIO_SX_BASE,
    pointerEvents: "none",
    p: 0,
    color: contrast,
    "&.Mui-checked": { color: contrast },
  };
}

export function getUnselectedRadioSx(passes: boolean): SxProps<Theme> {
  return {
    ...RADIO_SX_BASE,
    ...(passes
      ? { color: "text.secondary" }
      : { color: "error.main", opacity: 1 }),
  };
}
